import Vue from 'vue'
import Router from 'vue-router'
import CaAutoState from '@/components/caAutoState.vue'
// <CaAutoState msg="Welcome to Your Vue.js App"/>
Vue.use(Router)
const createRouter = () => new Router({
    /** 去掉项目中的url的# **/
    mode: process.env.NODE_ENV === 'development' ? 'history' : '',
    base: process.env.NODE_ENV === 'development' ? process.env.BASE_URL : '',
    routes: [{
            path: '/',
            redirect: '/views/caAutoState'
        },
        {
            path: '/views/caAutoState',
            name: 'Login',
            component: CaAutoState,
        }
    ]
})
const router = createRouter()
export default router